module.exports = __webpack_public_path__ + "static/media/lineto-circular-bold.0f01eae4.woff";